@let acceptButtonReady = acceptButtonReady$ | async;

<div
  class="msg-box-v2"
  [ngClass]="settings?.customOverlayClass"
>
  <div class="kros-modal-header">
    <div
      class="modal-line"
      [ngClass]="modalLineClass"
    ></div>
    <div class="modal-title">
      @if (settings?.icon && effectiveNewDesign) {
        <div
          class="modal-title-icon"
          [ngClass]="'modal-title-icon-' + messageType().toLowerCase()"
        >
          <i
            class="hgi hgi-stroke hgi-34"
            [ngClass]="settings?.icon + ' hgi-' + messageType().toLowerCase()"
          ></i>
        </div>
      }

      @if (settings) {
        @if (isString(settings.caption)) {
          <span class="h4">{{ settings.caption }}</span>
        } @else {
          <span class="h4">
            <ng-container *ngTemplateOutlet="getTemplateRef(settings.caption)"></ng-container>
          </span>
        }
      }
    </div>
    @if (showXButton) {
      <button
        class="btn btn-link close"
        aria-label="{{ 'COMMON.CLOSE' | translate }}"
        (click)="closeModal()"
      >
        @if (effectiveNewDesign) {
          <i class="hgi hgi-stroke hgi-cancel-01 message-box-cancel"></i>
        } @else {
          <i
            class="material-icons secondary"
            aria-hidden="true"
          >
            close
          </i>
        }
      </button>
    }
  </div>

  <div
    class="kros-modal-body line-break"
    [ngClass]="settings?.customBodyClass"
  >
    @if (isString(settings.message)) {
      <div
        [innerHTML]="settings.message"
      ></div>
    } @else {
      <ng-container *ngTemplateOutlet="$any(settings.message)"></ng-container>
    }

    @if (confirmByText) {
      <kros-form-field class="mt-4">
        <kros-label>{{ settings?.confirmation?.label ?? '' }}</kros-label>
        <input
          krosControl
          [formControl]="confirmationString"
          name="confirmationString"
          type="text"
          class="form-control"
          data-test="confirmation-string-input"
          maxLength="100"
        />
      </kros-form-field>
    }
  </div>

  <div class="kros-modal-footer">
    @if (isString(settings.acceptButton) && settings.acceptButton) {
      <button
        #acceptButton
        type="button"
        class="btn btn-submit"
        data-test="message-box-yes"
        [ngClass]="buttonType_v2"
        (click)="submitModal('accept')"
        [disabled]="!acceptButtonReady || !isConfirmAllowed()"
        krosTooltip="{{ confirmByText && !isConfirmAllowed() ? settings.confirmation?.tooltip : '' }}"
      >
        @if (!acceptButtonReady) {
          <kros-save-indicator
            class="indicator"
            [state]="SaveIndicatorState.InProgress"
          ></kros-save-indicator>
        }
        <span class="accept-btn-text">{{ settings.acceptButton }}</span>
      </button>
    } @else if (!isString(settings.acceptButton)) {
      <ng-container *ngTemplateOutlet="$any(settings.acceptButton); context: msgBoxContext"></ng-container>
    }

    @if (isString(settings.cancelButton) && settings.cancelButton) {
      <button
        #cancelButton
        type="button"
        class="btn btn-submit"
        [ngClass]="btnCloseClass"
        data-test="message-box-no"
        (click)="submitModal('cancel')">
        {{ settings.cancelButton }}
      </button>
    } @else if (!isString(settings.cancelButton)) {
      <ng-container *ngTemplateOutlet="$any(settings.cancelButton); context: msgBoxContext"></ng-container>
    }
  </div>
</div>
